// extracted by mini-css-extract-plugin
export default {"container":"styles_container__opHvo","title":"styles_title__sHtja","store-type-badge":"styles_store-type-badge__mdjcV"};